import { useSiteSearchApi, useSiteSearchCondition } from '@/common/api/modules/site'
import { useFirstLoading } from '@/common/api/search'
import { siteNewPath } from '@/common/app/path'

import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import Area from '@/components/view/layouts/area/Area'
import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageListLoading from '@/components/view/molecules/loading/PageListLoading'
import PageListSearching from '@/components/view/molecules/loading/PageListSearching'
import NoResultGuidance from '@/components/view/molecules/search/NoResultGuidance'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import SiteListTable from '@/components/container/modules/admin/site/table/SiteListTable'
import TitlePageInfo from '@/components/container/utils/pager/TitlePageInfo'

const SiteListPage = () => {
  const [condition, setCondition, onUpdatePage] = useSiteSearchCondition()
  const { data, error, isLoading, mutate } = useSiteSearchApi(condition)

  const isFirstLoading = useFirstLoading(isLoading)

  return (
    <Main type={MainLayoutType.FULL}>
      <PageTitle
        title={'サイト管理'}
        description='クライアントのサイト一覧'
        behindNode={
          data && (
            <TitlePageInfo
              page={condition.page}
              perPage={condition.perPage}
              total={data.length}
              unit={'件'}
            />
          )
        }
        rightNode={
          <>
            <Button link={siteNewPath()} size='large' color={ButtonColor.PRIMARY_BRAND}>
              新規サイトを追加する
            </Button>
          </>
        }
      />
      <Content>
        {isFirstLoading ? (
          <PageListLoading />
        ) : (
          <Area tableWrap noBorder>
            {/* <SiteSearchConditionField condition={condition} setCondition={setCondition} /> */}
            {isLoading ? (
              <PageListSearching />
            ) : data && data.length > 0 ? (
              <>
                <SiteListTable
                  sites={data}
                  onUpdatePage={onUpdatePage}
                  total={data.length}
                  condition={condition}
                  setCondition={setCondition}
                />
              </>
            ) : (
              <NoResultGuidance searched name='サイト' />
            )}
          </Area>
        )}
      </Content>
    </Main>
  )
}

export default SiteListPage
